// extracted by mini-css-extract-plugin
export default {"buttonBack_desktop":"buttonBack_desktop_Tjrbh4Q"};